import { IApplicationState } from '../../types/redux';

export const selectServiceMessage = (state: IApplicationState) => state.serviceMessage;
